<script lang="ts">
  import Aquarium from './Aquarium.svelte';
  export let name: string;
</script>

<main>
  <h1>Sharkku Aquarium!</h1>
  <Aquarium></Aquarium>
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  .fish-tank {
    width: 100%;
    height: 100%;
    background-color: #c7ddff;
    position: relative;
    overflow: hidden;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
